<template>
  <div>
    <Loader :isLoading="isLoading" />
    <VerificationEmail v-if="!emailVerified" />
    <div v-if="emailVerified && section" class="wide-width">
      <SectionCard class="section-card" :name="sectionName" :imageUrl="sectionThumbUrl" :desc="sectionDesc"
        :showFullDescription="true" :loading="isLoading" />

      <div v-if="!isLoading">
        <div v-if="sectionPackages.length" class="row">
          <div class="col-12">
            <div class="my-2">
              <small class="text-muted">{{ count }} packages</small>
            </div>
          </div>
        </div>
        <div v-else class="my-4 text-center">
          <p class="empty-dataset">Nothing for Sale</p>
        </div>
      </div>

      <div v-if="isLoading">
        <div class="row">
          <div class="col-12">
            <b-skeleton width="25%" height="40px" class="mt-4 mb-3"></b-skeleton>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mb-5">
            <div class="grid-container">
              <CatalogCard :loading="isLoading" />
              <CatalogCard :loading="isLoading" />
              <CatalogCard :loading="isLoading" />
              <CatalogCard :loading="isLoading" />
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row">
          <div class="col-12 mb-5">
            <div class="grid-container">
              <CatalogCard v-for="pack in sectionPackages" :key="pack.id" :catalogPackage="pack"
                :section="pack.get('section')" :loading="isLoading" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="!section && !isLoading" class="text-center">
      <p class="empty-dataset">Section not found</p>
      </div>
  </div>
</template>

<script>
import CatalogCard from "../components/CatalogCard";
import SectionCard from "../components/SectionCard";
import VerificationEmail from "../components/VerificationEmail";
import Loader from "../components/Loader";
import DataService from "../services/DataService";
import { mapGetters } from "vuex";
import { captureAffiliate } from "../helpers/packages";
import { setMetaTags } from '../helpers/utils';

const ds = DataService.getInstance();

export default {
  name: "Catalog",
  components: {
    CatalogCard,
    SectionCard,
    VerificationEmail,
    Loader,
  },
  props: {
    sectionslug: String,
  },
  data () {
    return {
      isLoading: true,
      section: null,
      sectionPackages: {},
      count: 0,
      emailVerified: true,
    };
  },
  async created () {
    ga("set", "page", "/catalog.html");
    ga("send", "pageview");

    // check email verified
    let user = Parse.User.current();
    if (user) {
      // update user if possibly out of date
      if (!user.get("emailVerified")) {
        user = await Parse.User?.current()?.fetch();
      }
      this.emailVerified = user.get("emailVerified");
      if (!this.emailVerified) {
        this.isLoading = false;
        return;
      }
    }

    await this.$store.dispatch("settings/getAppSettings");
    
    const queryPromises = [this.getSection(), this.getPackages()];
    await Promise.all(queryPromises);
    
    setMetaTags({ title: `${this.sectionName || 'No Section Found'} | ${this.bandName}`, description: this.sectionDesc, image: this.sectionThumbUrl });
    this.isLoading = false;
  },
  methods: {
    async getSection () {
      try {
        this.section = await ds.getSection(this.sectionslug);
        if (this.section && this.section.slug && this.sectionslug != this.section.slug) {
          this.$router.push(`/sections/${this.section.slug}`);
        }
        if (this.section) {
          captureAffiliate({ sectionId: this.section.objectId });
        }
      } catch (err) {
        this.$bvToast.toast(err.message, {
          variant: "danger",
        });
      }
    },
    async getPackages () {
      try {
        let pckages = await ds.getSectionCatalog(this.sectionslug);
        this.count = pckages.length;
        this.sectionPackages = pckages;
      } catch (err) {
        this.$bvToast.toast(err.message, {
          variant: "danger",
        });
      }
    },
  },
  computed: {
    ...mapGetters("settings", ["currency", "bandName"]),
    sectionName () {
      return this.section ? this.section.name : null;
    },
    sectionDesc () {
      return this.section ? this.section.desc : null;
    },
    sectionThumbUrl () {
      return this.section && this.section.image ? this.section.image._url : this.$paidutils.getNoImageURL();
    },
  },
};
</script>

<style scoped>
.section-card {
  padding-bottom: 4rem;
}

.grid-container {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
}

@media (max-width: 768px) {
  .grid-container {
    grid-template-columns: repeat(auto-fill, minmax(165px, 1fr));
  }
}
</style>
